document.addEventListener('DOMContentLoaded', function() {
  var vatToggles = document.querySelectorAll('.vat-toggle-checkbox');
  var vatStatusLabels = document.querySelectorAll('.vat-status-label');
  var bodyEl = document.body;
  var VAT_RATE = 1.20;

  function getTicker() {
    return document.getElementById('priceTicker') || document.querySelector('[data-origmoney]');
  }

  function updatePriceTicker(isInclusive) {
    var ticker = getTicker();
    if (!ticker) return;
    var exVatStr = ticker.dataset.origmoney || ticker.dataset.exVat || ticker.textContent.replace(/[^0-9.]/g, '');
    var exVat = parseFloat(exVatStr);
    if (isNaN(exVat)) return;
    ticker.dataset.exVat = String(exVat);
    ticker.textContent = isInclusive ? (exVat * VAT_RATE).toFixed(2) : exVat.toFixed(2);
  }

  function isVatInclusiveNow() {
    var stored = localStorage.getItem('vat-inclusive');
    return stored === null ? true : stored === 'true';
  }

  function setVatStatus(isInclusive) {
    localStorage.setItem('vat-inclusive', isInclusive);
    bodyEl.classList.toggle('vat-inclusive', isInclusive);
    bodyEl.classList.toggle('vat-exclusive', !isInclusive);
    vatStatusLabels.forEach(function(l) { if (l) l.textContent = isInclusive ? 'Inc VAT' : 'Ex VAT'; });
    vatToggles.forEach(function(t) { if (t) t.checked = isInclusive; });
    updatePriceTicker(isInclusive);
  }

  setVatStatus(isVatInclusiveNow());
  vatToggles.forEach(function(t) {
    t.addEventListener('change', function(e) { setVatStatus(e.target.checked); });
  });

  var watchedTickers = new Set();
  function applyVatToTicker() {
    var ticker = getTicker();
    if (!ticker) return false;
    updatePriceTicker(isVatInclusiveNow());
    if (!watchedTickers.has(ticker)) {
      watchedTickers.add(ticker);
      var obs = new MutationObserver(function() {
        requestAnimationFrame(function() { updatePriceTicker(isVatInclusiveNow()); });
      });
      obs.observe(ticker, { attributes: true, attributeFilter: ['data-origmoney'] });
    }
    return true;
  }

  function hasTicker(node) {
    return node.id === 'priceTicker' || (node.hasAttribute && node.hasAttribute('data-origmoney')) || (node.querySelector && node.querySelector('#priceTicker, [data-origmoney]'));
  }

  var bodyObs = new MutationObserver(function(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var node = nodes[j];
        if (node.nodeType !== 1) continue;
        node.querySelectorAll('.vat-toggle-checkbox').forEach(function(t) {
          t.checked = isVatInclusiveNow();
          t.addEventListener('change', function(e) { setVatStatus(e.target.checked); });
        });
        if (hasTicker(node)) {
          [100, 600, 1600, 3000].forEach(function(ms) {
            setTimeout(applyVatToTicker, ms);
          });
        }
      }
    }
  });
  bodyObs.observe(document.body, { childList: true, subtree: true });

  window.vatToggle = { updatePriceTicker: updatePriceTicker, isVatInclusiveNow: isVatInclusiveNow };

  if (!applyVatToTicker()) {
    var n = 0;
    var poll = setInterval(function() {
      if (applyVatToTicker() || n++ > 75) clearInterval(poll);
    }, 200);
  }
});
